import { render, staticRenderFns } from "./RelatedPositionAdder.vue?vue&type=template&id=5040ff17&scoped=true"
import script from "./RelatedPositionAdder.vue?vue&type=script&lang=js"
export * from "./RelatedPositionAdder.vue?vue&type=script&lang=js"
import style0 from "./RelatedPositionAdder.vue?vue&type=style&index=0&id=5040ff17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5040ff17",
  null
  
)

export default component.exports